export { CartItemsTray } from './CartItemsTray';
export { CartItemsTrayWithSimilarDesigns } from './CartItemsTrayWithSimilarDesigns';
